import { ErrorStateMatcher } from '@angular/material/core';

export class ShowOnDirtyAnTouchedErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control) {
    return control && control.invalid && control.dirty && control.touched;
  }
}
